"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.white = exports.utilityWarningYellowPressed = exports.utilityWarningYellowHover = exports.utilityWarningYellow = exports.utilityValidGreenPressed = exports.utilityValidGreenHover = exports.utilityValidGreen = exports.utilityErrorRedPressed = exports.utilityErrorRedHover = exports.utilityErrorRed = exports.utilityActionBluePressed = exports.utilityActionBlueHover = exports.utilityActionBlue = exports.utility = exports.primary = exports.overlay90 = exports.overlay50 = exports.overlay = exports.ministryYoungAdultLifeGroups = exports.ministryWomensLifeGroups = exports.ministryWatchPartyLifeGroups = exports.ministrySinglesLifeGroups = exports.ministrySharedInterestsLifeGroups = exports.ministryServing = exports.ministryOpenNetwork = exports.ministryNeighborLifeGroups = exports.ministryMentorLifeGroups = exports.ministryMensLifeGroups = exports.ministryMarriedLifeGroups = exports.ministryLocalMissions = exports.ministryLifeMissions = exports.ministryLifeKids2 = exports.ministryLifeKids1 = exports.ministryLifeGroupsOld = exports.ministryLifeGroupsNew = exports.ministryGiving = exports.ministryColors = exports.ministryCollegeLifeGroups = exports.ministryBaptism = exports.lcRed = exports.lcBlack = exports.labels = exports.gray80 = exports.gray50 = exports.gray5 = exports.gray30 = exports.gray130 = exports.gray100 = exports.gray10 = exports.gray = exports.connectRenew = exports.connectPrayer = exports.connectOpenDoor = exports.connectNewHere = exports.connectConnect = exports.connectCommitment = exports.connect = exports.black = void 0;
/**
 * @module Colors
 */
// ----------------------------------------------
// Top-level Variables
// ----------------------------------------------
// Core + Brand
const black = exports.black = '#000000';
const primary = exports.primary = '#009ecc';
const white = exports.white = '#ffffff';
const lcBlack = exports.lcBlack = '#000000';
const lcRed = exports.lcRed = '#a6192e';

// Grayscale
const gray5 = exports.gray5 = '#f6f6f6';
const gray10 = exports.gray10 = '#ececec';
const gray30 = exports.gray30 = '#c6c6c6';
const gray50 = exports.gray50 = '#9f9fa0';
const gray80 = exports.gray80 = '#666667';
const gray100 = exports.gray100 = '#404041';
const gray130 = exports.gray130 = '#2d2d2e';

// Connect Colors
const connectCommitment = exports.connectCommitment = '#701789';
const connectConnect = exports.connectConnect = '#009ecc';
const connectNewHere = exports.connectNewHere = '#36d3e8';
const connectOpenDoor = exports.connectOpenDoor = '#a6192e';
const connectPrayer = exports.connectPrayer = '#ffba0c';
const connectRenew = exports.connectRenew = '#e33300';

// Ministry Colors
const ministryBaptism = exports.ministryBaptism = '#004e7c';
const ministryCollegeLifeGroups = exports.ministryCollegeLifeGroups = '#edb902';
const ministryGiving = exports.ministryGiving = '#09c1a1';
const ministryLifeGroupsNew = exports.ministryLifeGroupsNew = '#00946d';
const ministryLifeGroupsOld = exports.ministryLifeGroupsOld = '#76c24e';
const ministryLifeKids1 = exports.ministryLifeKids1 = '#402061';
const ministryLifeKids2 = exports.ministryLifeKids2 = '#ffda24';
const ministryLifeMissions = exports.ministryLifeMissions = '#00788c';
const ministryLocalMissions = exports.ministryLocalMissions = '#ff4612';
const ministryMarriedLifeGroups = exports.ministryMarriedLifeGroups = '#791495';
const ministryMensLifeGroups = exports.ministryMensLifeGroups = '#2859a6';
const ministryMentorLifeGroups = exports.ministryMentorLifeGroups = '#3eab94';
const ministryNeighborLifeGroups = exports.ministryNeighborLifeGroups = '#373a36';
const ministryOpenNetwork = exports.ministryOpenNetwork = '#2993e5';
const ministryServing = exports.ministryServing = '#1c70c9';
const ministrySharedInterestsLifeGroups = exports.ministrySharedInterestsLifeGroups = '#1babdb';
const ministrySinglesLifeGroups = exports.ministrySinglesLifeGroups = '#f26623';
const ministryWatchPartyLifeGroups = exports.ministryWatchPartyLifeGroups = '#1c2023';
const ministryWomensLifeGroups = exports.ministryWomensLifeGroups = '#de3182';
const ministryYoungAdultLifeGroups = exports.ministryYoungAdultLifeGroups = '#1e6e3c';

// Utility Colors
const utilityActionBlue = exports.utilityActionBlue = '#009ecc';
const utilityActionBlueHover = exports.utilityActionBlueHover = '#00b3e5';
const utilityActionBluePressed = exports.utilityActionBluePressed = '#008bb2';
const utilityErrorRed = exports.utilityErrorRed = '#e33300';
const utilityErrorRedHover = exports.utilityErrorRedHover = '#f5441d';
const utilityErrorRedPressed = exports.utilityErrorRedPressed = '#cc2e00';
const utilityValidGreen = exports.utilityValidGreen = '#09c1a1';
const utilityValidGreenHover = exports.utilityValidGreenHover = '#23e0bf';
const utilityValidGreenPressed = exports.utilityValidGreenPressed = '#01ad8f';
const utilityWarningYellow = exports.utilityWarningYellow = '#ffba0c';
const utilityWarningYellowHover = exports.utilityWarningYellowHover = '#ffcd4f';
const utilityWarningYellowPressed = exports.utilityWarningYellowPressed = '#edaa00';

// Overlays
const overlay50 = exports.overlay50 = 'rgba(0, 0, 0, 0.5)';
const overlay90 = exports.overlay90 = 'rgba(0, 0, 0, 0.9)';

// ----------------------------------------------
// Object-based Color Groups
// ----------------------------------------------
const gray = exports.gray = Object.freeze({
  5: '#f6f6f6',
  10: '#ececec',
  30: '#c6c6c6',
  50: '#9f9fa0',
  80: '#666667',
  100: '#404041',
  130: '#2d2d2e'
});
const connect = exports.connect = Object.freeze({
  commitment: '#701789',
  connect: '#009ecc',
  newHere: '#36d3e8',
  openDoor: '#a6192e',
  prayer: '#ffba0c',
  renew: '#e33300'
});
const ministryColors = exports.ministryColors = Object.freeze({
  baptism: '#004e7c',
  collegeLifeGroups: '#edb902',
  giving: '#09c1a1',
  lifeGroupsNew: '#00946d',
  lifeGroupsOld: '#76c24e',
  lifeKids1: '#402061',
  lifeKids2: '#ffda24',
  lifeMissions: '#00788c',
  localMissions: '#ff4612',
  marriedLifeGroups: '#791495',
  mensLifeGroups: '#2859a6',
  mentorLifeGroups: '#3eab94',
  neighborLifeGroups: '#373a36',
  openNetwork: '#2993e5',
  serving: '#1c70c9',
  sharedInterestsLifeGroups: '#1babdb',
  singlesLifeGroups: '#f26623',
  watchPartyLifeGroups: '#1c2023',
  womensLifeGroups: '#de3182',
  youngAdultLifeGroups: '#1e6e3c'
});
const labels = exports.labels = Object.freeze({
  blue: {
    background: {
      dark: '#12718d',
      light: '#f2fafc'
    },
    text: {
      dark: '#f2fafc',
      light: '#009ecc'
    }
  },
  green: {
    background: {
      dark: '#1b7768',
      light: '#effbf9'
    },
    text: {
      dark: '#effbf9',
      light: '#09c1a1'
    }
  },
  red: {
    background: {
      dark: '#711a00',
      light: '#fdf4f1'
    },
    text: {
      dark: '#fdf4f1',
      light: '#e33300'
    }
  },
  yellow: {
    background: {
      dark: '#816520',
      light: '#fdf4f1'
    },
    text: {
      dark: '#fffbf0',
      light: '#ffba0c'
    }
  }
});
const utility = exports.utility = Object.freeze({
  action: {
    active: '#008bb2',
    base: '#009ecc',
    hover: '#00b3e5'
  },
  error: {
    active: '#cc2e00',
    base: '#e33300',
    hover: '#f5441d'
  },
  giving: {
    active: '#01ad8f',
    base: '#09c1a1',
    hover: '#23e0bf'
  },
  valid: {
    active: '#01ad8f',
    base: '#09c1a1',
    dark: '#23e0bf'
  },
  warning: {
    active: '#edaa00',
    base: '#ffba0c',
    hover: '#ffcd4f'
  }
});
const overlay = exports.overlay = Object.freeze({
  50: 'rgba(0, 0, 0, 0.5)',
  90: 'rgba(0, 0, 0, 0.9)'
});